import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, CardTitle, Modal, ModalFooter, Alert, Row, Col, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import useFirstLogin from 'framework/customHooks/useFirstLogin';


// Get version from environment variable
const version = process.env.REACT_APP_VERSION;

const WhatsNew = () => {
  const { isFirstLogin, updateFirstLoginStatus , features} = useFirstLogin(); // Use the custom hook
  const [activeTab, setActiveTab] = useState('1'); // Tab 1 for New Features, Tab 2 for Bug Fixes
  const [modalOpen, setModalOpen] = useState(isFirstLogin); // Manage modal visibility using local state

useEffect(() => {

    if (isFirstLogin) {
        setModalOpen(true); // Open the modal if it's the user's first login
    }

}, [isFirstLogin]);

  const toggleModal = () => {
    // Update the first login status when closing the modal
    updateFirstLoginStatus();
    setModalOpen(false); // Close the modal
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  if (!modalOpen) return null; // Do not render if modal is not open

  return (
    <Modal isOpen={modalOpen} toggle={toggleModal} centered backdrop="static">
      <Card>
        <CardBody>
          <CardTitle tag="h5">What's New (v{version})</CardTitle>

          <Row>
            <Col>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '1' })}
                    onClick={() => toggleTab('1')}
                  >
                    New Features
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '2' })}
                    onClick={() => toggleTab('2')}
                  >
                    Bug Fixes
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                  <Alert color="info">
                    <h6>New Features:</h6>
                    <ul>
                      {features.newFeatures.map((feature, index) => (
                        <li key={index}>{feature}</li>
                      ))}
                    </ul>
                  </Alert>
                </TabPane>
                <TabPane tabId="2">
                  <Alert color="warning">
                    <h6>Bug Fixes:</h6>
                    <ul>
                      {features.bugFixes.map((fix, index) => (
                        <li key={index}>{fix}</li>
                      ))}
                    </ul>
                  </Alert>
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <ModalFooter>
        <Button color="secondary" onClick={toggleModal}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default WhatsNew;
